import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AlertsService } from '../../../core/services/alerts.service';
import { AuthApiService } from '../../../core/modules/auth/auth-api.service';

@Component({
  selector: 'tax-simple-login',
  templateUrl: './simple-login.component.html',
  styleUrls: ['./simple-login.component.sass'],
})
export class SimpleLoginComponent implements OnDestroy {
  model = {
    login: '',
    secret: '',
    rememberMe: false,
  };

  loading = false;
  hasError = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private authApiService: AuthApiService,
    private alertsService: AlertsService,
  ) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  logIn(): void {
    this.hasError = true;
    this.loading = true;
    this.authApiService.singIn(this.model)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.router.navigate(['main/kkms']),
        error: (e: any) => {
          if (e.error.errorCode === 'blocked.user.error') {
            this.alertsService.add({
              type: 'danger',
              title: e.error.errorCode,
              message: 'blocked.user.error.description',
            });
          }
          this.hasError = true;
          this.loading = false;
        },
      });
  }
}
